// Full registration intake -- iteration 151. Composes a child, health record
// (145), optional club enrollment (149) and one or two guardians from the 2026
// registration form into a single submission.
import { z } from "zod";

const guardianSchema = z.object({
  name: z.string().min(1, "Guardian name is required").max(255),
  email: z.string().email("Valid guardian email is required"),
  phone: z.string().max(50).nullable().optional(),
});

export const registrationIntakeSchema = z.object({
  child: z.object({
    first_name: z.string().max(255).nullable().optional(),
    surname: z.string().max(255).nullable().optional(),
    date_of_birth: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "DOB must be YYYY-MM-DD"),
    grade: z.number().int().min(1).max(12).nullable().optional(),
  }).refine((c) => (c.first_name?.trim() || c.surname?.trim()), {
    message: "At least one of child first name or surname is required",
  }),
  health: z
    .object({
      medical_conditions: z.string().max(2000).nullable().optional(),
      allergies: z.string().max(2000).nullable().optional(),
      has_medical_aid: z.boolean().optional(),
      medical_aid_name: z.string().max(255).nullable().optional(),
      medical_aid_number: z.string().max(100).nullable().optional(),
      emergency_contact_name: z.string().max(255).nullable().optional(),
      emergency_contact_phone: z.string().max(50).nullable().optional(),
    })
    .optional(),
  // optional season enrollment + club affiliation (149)
  sport_id: z.string().min(1).nullable().optional(),
  club_id: z.string().min(1).nullable().optional(),
  guardians: z.array(guardianSchema).min(1, "At least one guardian is required").max(2),
});

export type RegistrationIntakeInput = z.infer<typeof registrationIntakeSchema>;
